import { render } from "./SportBetsPending.vue?vue&type=template&id=f3908c92"
import script from "./SportBetsPending.vue?vue&type=script&lang=js"
export * from "./SportBetsPending.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__